var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-text-tooltip"},[_c('v-tooltip',_vm._b({attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.$attrs,false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }